// extracted by mini-css-extract-plugin
export default {"queryContainer":"ChangelogPage_queryContainer__CeWup","closeButton":"ChangelogPage_closeButton__IAem2"};